import DodonesListItem from 'app/dodones/list/Item'

export default ({ dodones, ListItemElement, scroll = true }) => {
  const ListItem = ListItemElement || DodonesListItem

  return <div className="fcol flex-1">
           <div className="fcol flex-1" style={{ overflowY: scroll ? 'scroll' : 'none' }}>
             {
               Object.entries(dodones).map(([index, dodone]) => {
                 return <ListItem key={ index } dodone={ dodone } />
               })
             }
           </div>
         </div>;
};
